import React, { useMemo } from 'react';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import { TableResponsive } from '../../../components/common/TableResponsive';
import { getFollowUpColumns, useFollowUpList } from './FollowUpList';
import './EnquiryList/EnquiryList.css';

const FollowUp = () => {
    const {
        followups,
        districtList,
        selectedDistrict,
        setSelectedDistrict,
        isLoading,
        selectedDate,
        setSelectedDate,
        formattedDate,
        handleFollowSuccess,
        handleReport
    } = useFollowUpList();

    const columns = useMemo(
        () => getFollowUpColumns({ formattedDate, handleFollowSuccess, handleReport }),
        [formattedDate, handleFollowSuccess, handleReport]
    );

    return (
        <>
            <BreadCrumb title="Follow UP" prevPage="Home" prevPath="/dashboard" />
            <Row>
                <Col xs={12}>
                    <Card className="border-0 shadow-sm">
                        <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2 py-3 px-3 px-md-4 bg-transparent border-bottom">
                            {/* Title & Count Badge */}
                            <div className="d-flex align-items-center gap-2">
                                <h5 className="card-title mb-0 fs-15 fw-bold text-body">Follow-Up List</h5>
                                {!isLoading && (
                                    <span className="badge bg-soft-primary text-primary fs-11 px-2 py-0.5">
                                        {followups.length} {followups.length === 1 ? 'Record' : 'Records'}
                                    </span>
                                )}
                            </div>

                            {/* Filters: District Filter & Date Filter */}
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {/* District Filter (User requested) */}
                                <div className="d-flex align-items-center gap-1.5">
                                    <span className="fs-12 text-muted fw-medium text-nowrap">
                                        <i className="ri-building-line me-1" />
                                        District:
                                    </span>
                                    <select
                                        className="form-select form-select-sm fs-12"
                                        style={{ width: 'auto', minWidth: '135px' }}
                                        value={selectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                    >
                                        <option value="all">All Districts</option>
                                        {districtList.map((dist) => (
                                            <option key={dist} value={dist}>
                                                {dist}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Date Filter */}
                                <div className="d-flex align-items-center gap-1.5">
                                    <span className="fs-12 text-muted fw-medium text-nowrap">
                                        <i className="ri-calendar-line me-1" />
                                        Filter Date:
                                    </span>
                                    <input
                                        type="date"
                                        id="followUpDateFilter"
                                        className="form-control form-control-sm fs-12"
                                        style={{ width: 'auto', minWidth: '140px' }}
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                    >
                                    </input>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={followups}
                                noRecord="No Pending Follow-ups for Selected Filter"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default FollowUp;
